import { useEffect, useState } from "react";
import { Camera } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const VisionChip = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const h = window.innerHeight;
      // Show after the user passes the hero
      const past = y > h * 0.6;

      // Hide while we're inside the booking section so it doesn't
      // sit on top of the form
      const book = document.getElementById("book");
      let inBook = false;
      if (book) {
        const r = book.getBoundingClientRect();
        inBook = r.top < h * 0.6 && r.bottom > h * 0.2;
      }
      // Hide near the very bottom (footer) too
      const nearBottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 120;

      setVisible(past && !inBook && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href="#book"
          data-testid="vision-chip"
          initial={{ opacity: 0, y: 24, scale: 0.94 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 12, scale: 0.96 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed z-40 bottom-5 right-5 md:bottom-8 md:right-8 group"
        >
          <span className="flex items-center gap-3 pl-5 pr-6 py-3.5 bg-[#2A2A2A] text-[#F9F8F6] shadow-[0_10px_40px_-10px_rgba(42,42,42,0.55)] backdrop-blur-md hover:bg-[#C48B71] transition-colors duration-500 rounded-full">
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#C48B71] group-hover:bg-[#2A2A2A] transition-colors duration-500">
              <Camera size={14} strokeWidth={1.6} className="text-[#F9F8F6]" />
            </span>
            <span className="serif italic text-[1rem] tracking-tight">
              What's your <span className="not-italic font-normal">Main Vision?</span>
            </span>
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};

export default VisionChip;
